import { getConfig } from 'config'

const devEnvs = ['development', 'dev']
const config = await getConfig()

export const isDevelopment = devEnvs.includes(
  process.env.NODE_ENV.toLowerCase()
)
export async function isAdyenDevelopment() {
  return devEnvs.includes(config.adyenEnv.toLowerCase())
}
